const VERSION = '6.2.0';

export { VERSION };
